/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Done_Subscribed_SubInputs */

const en_funnel_done_subscribed_sub = /** @type {(inputs: Funnel_Done_Subscribed_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account already has a plan, so we didn't start a new one. Your card was not charged.`)
};

const es_funnel_done_subscribed_sub = /** @type {(inputs: Funnel_Done_Subscribed_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta cuenta ya tiene un plan, así que no iniciamos uno nuevo. No se hizo ningún cargo a tu tarjeta.`)
};

/**
* | output |
* | --- |
* | "This account already has a plan, so we didn't start a new one. Your card was not charged." |
*
* @param {Funnel_Done_Subscribed_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_done_subscribed_sub = /** @type {((inputs?: Funnel_Done_Subscribed_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Done_Subscribed_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_done_subscribed_sub(inputs)
	return en_funnel_done_subscribed_sub(inputs)
});